// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { clearAuthStorage, getCurrentUser } from '@/utils/auth';

type PageBodyResult<T> = API.CommonResult & { data?: T };
const DEFAULT_MENU_TERMINAL_TYPE = 'PC';
const DEFAULT_MENU_LEVEL_CODE = 'ALL';

/** 获取当前用户（本地登录态） */
export async function currentUser() {
  return Promise.resolve({
    data: getCurrentUser(),
  });
}

/** 退出登录（本地清理） */
export async function outLogin(options?: { [key: string]: any }) {
  try {
    return await request<Record<string, any>>('/dev-ops-api/login/logout', {
      method: 'POST',
      ...(options || {}),
    });
  } finally {
    clearAuthStorage();
  }
}

/** 登录接口 POST /dev-ops-api/login/doLogin */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/dev-ops-api/login/doLogin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      loginName: body.loginName,
      password: body.password,
    },
    ...(options || {}),
  });
}

/** 分页查询业态列表 POST /dev-ops-api/business/page */
export async function businessPage(
  body: API.BusinessPageParams,
  options?: { [key: string]: any },
) {
  return request<PageBodyResult<API.BusinessPageData>>(
    '/dev-ops-api/business/page',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        ...body,
      },
      ...(options || {}),
    },
  );
}

/** 分页查询业态版本列表 POST /dev-ops-api/businessVersion/page */
export async function businessVersionPage(
  body: API.BusinessVersionPageParams,
  options?: { [key: string]: any },
) {
  return request<PageBodyResult<API.BusinessVersionPageData>>('/dev-ops-api/businessVersion/page', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 新增业态版本 POST /dev-ops-api/businessVersion/addBusinessVersion */
export async function addBusinessVersion(
  body: API.BusinessVersionAddParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/businessVersion/addBusinessVersion', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      businessCode: body.businessCode,
      businessVersionName: body.businessVersionName,
      orgLevelCode: body.orgLevelCode,
      isDefault: body.isDefault,
      isShow: body.isShow,
      state: body.state,
      appVersions: body.appVersions,
    },
    ...(options || {}),
  });
}

/** 查询业态版本详情 GET /dev-ops-api/businessVersion/detail/{id} */
export async function detailBusinessVersion(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/businessVersion/detail/${encodedId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 修改业态版本 POST /dev-ops-api/businessVersion/updateBusinessVersion */
export async function updateBusinessVersion(
  body: API.BusinessVersionUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/businessVersion/updateBusinessVersion', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      id: body.id,
      businessCode: body.businessCode,
      businessVersionName: body.businessVersionName,
      orgLevelCode: body.orgLevelCode,
      isDefault: body.isDefault,
      isShow: body.isShow,
      state: body.state,
      appVersions: body.appVersions,
    },
    ...(options || {}),
  });
}

/** 删除业态版本 DELETE /dev-ops-api/businessVersion/delete/{id} */
export async function deleteBusinessVersion(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/businessVersion/delete/${encodedId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 获取应用版本下拉列表 POST /dev-ops-api/appVersion/getSelectList */
export async function appVersionSelectList(
  body?: API.AppVersionSelectParams,
  options?: { [key: string]: any },
) {
  return request<
    API.CommonResult | API.AppVersionSelectItem[] | { data?: API.AppVersionSelectItem[] }
  >('/dev-ops-api/appVersion/getSelectList', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 按业态查询默认/非默认应用版本 GET /dev-ops-api/appVersion/select/default/{id}/{type} */
export async function appVersionSelectDefault(
  id: string,
  type: 0 | 1,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  const encodedType = encodeURIComponent(String(type));
  return request<
    API.CommonResult | API.AppVersionSelectItem[] | { data?: API.AppVersionSelectItem[] }
  >(`/dev-ops-api/appVersion/select/default/${encodedId}/${encodedType}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 分页查询应用版本列表 POST /dev-ops-api/appVersion/page */
export async function appVersionPage(
  body: API.AppVersionPageParams,
  options?: { [key: string]: any },
) {
  return request<PageBodyResult<API.AppVersionPageData>>('/dev-ops-api/appVersion/page', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 新增应用版本 POST /dev-ops-api/appVersion/addAppVersion */
export async function addAppVersion(
  body: API.AppVersionSaveParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/appVersion/addAppVersion', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      appId: body.appId,
      appVersionName: body.appVersionName,
      appVersionDesc: body.appVersionDesc,
      appVersionPrice: body.appVersionPrice,
      menuIds: body.menuIds,
      state: body.state,
      configs: body.configs,
    },
    ...(options || {}),
  });
}

/** 查询应用版本详情 GET /dev-ops-api/appVersion/detail/{id} */
export async function detailAppVersion(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/appVersion/detail/${encodedId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 修改应用版本 POST /dev-ops-api/appVersion/updateAppVersion */
export async function updateAppVersion(
  body: API.AppVersionUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/appVersion/updateAppVersion', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      id: body.id,
      appId: body.appId,
      appVersionName: body.appVersionName,
      appVersionDesc: body.appVersionDesc,
      appVersionPrice: body.appVersionPrice,
      menuIds: body.menuIds,
      state: body.state,
      configs: body.configs,
    },
    ...(options || {}),
  });
}

/** 删除应用版本 DELETE /dev-ops-api/appVersion/delete/{id} */
export async function deleteAppVersion(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/appVersion/delete/${encodedId}`, {
    method: 'DELETE',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 获取组织级别下拉列表 GET /dev-ops-api/orgLevel/selectList */
export async function orgLevelSelectList(
  body?: API.OrgLevelSelectParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult | API.OrgLevelItem[] | { data?: API.OrgLevelItem[] }>(
    '/dev-ops-api/orgLevel/selectList',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        ...body,
      },
      ...(options || {}),
    },
  );
}

/** 新增业态 POST /dev-ops-api/business/addBusiness */
export async function addBusiness(
  body: API.BusinessSaveParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/business/addBusiness', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      businessCode: body.businessCode,
      businessName: body.businessName,
      sort: body.sort,
      state: body.state,
    },
    ...(options || {}),
  });
}

/** 修改业态 POST /dev-ops-api/business/updateBusiness */
export async function updateBusiness(
  body: API.BusinessUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/business/updateBusiness', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      id: body.id,
      businessCode: body.businessCode,
      businessName: body.businessName,
      sort: body.sort,
      state: body.state,
    },
    ...(options || {}),
  });
}

/** 删除业态 DELETE /dev-ops-api/business/delete/{id} */
export async function deleteBusiness(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/business/delete/${encodedId}`, {
    method: 'DELETE',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 查询业态详情 GET /dev-ops-api/business/detail/{id} */
export async function detailBusiness(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/business/detail/${encodedId}`, {
    method: 'GET',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 查询全部业态列表 GET /dev-ops-api/business/list */
export async function businessList(options?: { [key: string]: any }) {
  return request<API.CommonResult | API.BusinessItem[] | { data?: API.BusinessItem[] }>(
    '/dev-ops-api/business/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 分页查询应用列表 POST /dev-ops-api/app/page */
export async function appPage(
  body: API.AppPageParams,
  options?: { [key: string]: any },
) {
  return request<PageBodyResult<API.AppPageData>>('/dev-ops-api/app/page', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 查询应用列表 POST /dev-ops-api/app/list */
export async function appList(
  body?: API.AppListParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult | API.AppItem[] | { data?: API.AppItem[] }>(
    '/dev-ops-api/app/list',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: {
        ...body,
      },
      ...(options || {}),
    },
  );
}

/** 新增应用 POST /dev-ops-api/app/addApp */
export async function addApp(
  body: API.AppAddParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/app/addApp', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      appCode: body.appCode,
      appName: body.appName,
      appType: body.appType,
      subscribeUrl: body.subscribeUrl ?? '',
      upgradeUrl: body.upgradeUrl ?? '',
      appIcon: body.appIcon ?? '',
      appCategoryId: body.appCategoryId ?? '',
      appDesc: body.appDesc ?? '',
      scopeBusinessCode: body.scopeBusinessCode ?? '',
      appSource: body.appSource ?? '',
      isShow: body.isShow,
      state: body.state,
      defaultMenuId: body.defaultMenuId ?? '',
      configDefs: body.configDefs ?? [],
    },
    ...(options || {}),
  });
}

/** 修改应用 POST /dev-ops-api/app/updateApp */
export async function updateApp(
  body: API.AppUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/app/updateApp', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      id: body.id,
      appCode: body.appCode,
      appName: body.appName,
      appType: body.appType ?? '',
      subscribeUrl: body.subscribeUrl ?? '',
      upgradeUrl: body.upgradeUrl ?? '',
      appIcon: body.appIcon ?? '',
      appCategoryId: body.appCategoryId ?? '',
      scopeBusinessCode: body.scopeBusinessCode ?? '',
      appSource: body.appSource ?? '',
      isShow: body.isShow,
      state: body.state ?? '',
      defaultMenuId: body.defaultMenuId ?? '',
      configDefs: body.configDefs ?? [],
    },
    ...(options || {}),
  });
}

/** 查询应用详情 GET /dev-ops-api/app/detail/{id} */
export async function detailApp(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/app/detail/${encodedId}`, {
    method: 'GET',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 删除应用 DELETE /dev-ops-api/app/delete/{id} */
export async function deleteApp(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/app/delete/${encodedId}`, {
    method: 'DELETE',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 分页查询应用分类列表 POST /dev-ops-api/appCategory/page */
export async function appCategoryPage(
  body: API.AppCategoryPageParams,
  options?: { [key: string]: any },
) {
  return request<PageBodyResult<API.AppCategoryPageData>>('/dev-ops-api/appCategory/page', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      current: body.current,
      pageSize: body.pageSize,
      categoryName: body.categoryName ?? '',
    },
    ...(options || {}),
  });
}

/** 新增应用分类 POST /dev-ops-api/appCategory/add */
export async function addAppCategory(
  body: API.AppCategorySaveParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/appCategory/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      categoryName: body.categoryName ?? '',
      categoryDesc: body.categoryDesc ?? '',
    },
    ...(options || {}),
  });
}

/** 获取应用分类下拉列表 GET /dev-ops-api/appCategory/selectList */
export async function appCategorySelectList(options?: { [key: string]: any }) {
  return request<API.CommonResult | API.AppCategorySelectItem[] | { data?: API.AppCategorySelectItem[] }>(
    '/dev-ops-api/appCategory/selectList',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 查询应用分类详情 GET /dev-ops-api/appCategory/detail/{id} */
export async function detailAppCategory(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/appCategory/detail/${encodedId}`, {
    method: 'GET',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 修改应用分类 POST /dev-ops-api/appCategory/update */
export async function updateAppCategory(
  body: API.AppCategoryUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/appCategory/update', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      id: body.id,
      categoryName: body.categoryName ?? '',
      categoryDesc: body.categoryDesc ?? '',
    },
    ...(options || {}),
  });
}

/** 修改应用分类状态 POST /dev-ops-api/appCategory/updateState/{id} */
export async function updateAppCategoryState(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/appCategory/updateState/${encodedId}`, {
    method: 'POST',
    ...(options || {}),
  });
}

/** 删除应用分类 DELETE /dev-ops-api/appCategory/delete/{id} */
export async function deleteAppCategory(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/appCategory/delete/${encodedId}`, {
    method: 'DELETE',
    params: {
      id,
    },
    ...(options || {}),
  });
}

/** 查询菜单树 POST /dev-ops-api/menu/tree */
export async function menuTree(
  body?: API.MenuTreeParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult | API.MenuItem[] | { data?: API.MenuItem[] }>(
    '/dev-ops-api/menu/tree',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: {
        ...body,
        levelCode: body?.levelCode || DEFAULT_MENU_LEVEL_CODE,
        ownerType: body?.ownerType ?? '',
        ownerCode: body?.ownerCode ?? '',
        terminalType: body?.terminalType || DEFAULT_MENU_TERMINAL_TYPE,
      },
      ...(options || {}),
    },
  );
}

/** 查询菜单列表 GET /dev-ops-api/menu/list */
export async function menuList(options?: { [key: string]: any }) {
  return request<
    API.CommonResult | API.MenuItem[] | { data?: API.MenuItem[] }
  >('/dev-ops-api/menu/list', { method: 'GET', ...(options || {}) });
}

/** 分页查询菜单 POST /dev-ops-api/menu/page */
export async function menuPage(
  body: API.MenuPageParams,
  options?: { [key: string]: any },
) {
  return request<PageBodyResult<API.MenuPageData>>('/dev-ops-api/menu/page', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 查询菜单详情 GET /dev-ops-api/menu/detail/{id} */
export async function detailMenu(id: string, options?: { [key: string]: any }) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/menu/detail/${encodedId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

/** 新增菜单 POST /dev-ops-api/menu/addMenu */
export async function addMenu(
  body: API.MenuAddParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/menu/addMenu', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 修改菜单 POST /dev-ops-api/menu/updateMenu */
export async function updateMenu(
  body: API.MenuUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/menu/updateMenu', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 删除菜单 DELETE /dev-ops-api/menu/delete/{id} */
export async function deleteMenu(id: string, options?: { [key: string]: any }) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/menu/delete/${encodedId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function batchDeleteMenu(
  body: API.MenuBatchDeleteParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/menu/batchDelete', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function batchStateMenu(
  body: API.MenuBatchStateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/menu/batchState', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function batchOwnerMenu(
  body: API.MenuBatchOwnerParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/menu/batchOwner', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function batchLevelCodeMenu(
  body: API.MenuBatchLevelCodeParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/menu/batchLevelCode', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function recycleBinMenuTree(
  body?: API.MenuTreeParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult | API.MenuItem[] | { data?: API.MenuItem[] }>(
    '/dev-ops-api/menu/recycleBin/tree',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: {
        ...body,
        levelCode: body?.levelCode || DEFAULT_MENU_LEVEL_CODE,
        ownerType: body?.ownerType ?? '',
        ownerCode: body?.ownerCode ?? '',
        terminalType: body?.terminalType || DEFAULT_MENU_TERMINAL_TYPE,
      },
      ...(options || {}),
    },
  );
}

export async function restoreMenu(id: string, options?: { [key: string]: any }) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(
    `/dev-ops-api/menu/recycleBin/restore/${encodedId}`,
    { method: 'POST', ...(options || {}) },
  );
}

export async function permanentlyDeleteMenu(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(
    `/dev-ops-api/menu/recycleBin/delete/${encodedId}`,
    { method: 'DELETE', ...(options || {}) },
  );
}

/** 批量恢复回收站菜单 POST /dev-ops-api/menu/recycleBin/batchRestore */
export async function batchRestoreRecycleBinMenu(
  body: API.MenuRecycleBinBatchParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>(
    '/dev-ops-api/menu/recycleBin/batchRestore',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 批量彻底删除回收站菜单 POST /dev-ops-api/menu/recycleBin/batchDelete */
export async function batchDeleteRecycleBinMenu(
  body: API.MenuRecycleBinBatchParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>(
    '/dev-ops-api/menu/recycleBin/batchDelete',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 清空全局菜单回收站 DELETE /dev-ops-api/menu/recycleBin/clear */
export async function clearRecycleBinMenu(options?: { [key: string]: any }) {
  return request<API.CommonResult>('/dev-ops-api/menu/recycleBin/clear', {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 分页查询接口权限 POST /dev-ops-api/perm/page */
export async function apiPermPage(
  body: API.ApiPermPageParams,
  options?: { [key: string]: any },
) {
  return request<PageBodyResult<API.ApiPermPageData>>('/dev-ops-api/perm/page', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function apiPermDetail(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/perm/detail/${encodedId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function addApiPerm(
  body: API.ApiPermAddParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/perm/addPerm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function updateApiPerm(
  body: API.ApiPermUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/perm/updatePerm', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function deleteApiPerm(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/perm/delete/${encodedId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

export async function listApiPermByCategory(
  categoryId: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(categoryId);
  return request<API.CommonResult | API.ApiPermItem[] | { data?: API.ApiPermItem[] }>(
    `/dev-ops-api/perm/listByCategory/${encodedId}`,
    { method: 'GET', ...(options || {}) },
  );
}

export async function listApiPermByMenu(
  menuId: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(menuId);
  return request<API.CommonResult | API.ApiPermItem[] | { data?: API.ApiPermItem[] }>(
    `/dev-ops-api/perm/listByMenu/${encodedId}`,
    { method: 'GET', ...(options || {}) },
  );
}

export async function bindMenuApiPerm(
  body: API.BindMenuApiPermParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/perm/bindMenu', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function apiPermCategoryTree(options?: { [key: string]: any }) {
  return request<
    API.CommonResult | API.ApiPermCategoryItem[] | { data?: API.ApiPermCategoryItem[] }
  >('/dev-ops-api/perm/category/tree', { method: 'GET', ...(options || {}) });
}

export async function apiPermCategoryDetail(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/perm/category/detail/${encodedId}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function addApiPermCategory(
  body: API.ApiPermCategoryAddParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/perm/category/addCategory', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function updateApiPermCategory(
  body: API.ApiPermCategoryUpdateParams,
  options?: { [key: string]: any },
) {
  return request<API.CommonResult>('/dev-ops-api/perm/category/updateCategory', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

export async function deleteApiPermCategory(
  id: string,
  options?: { [key: string]: any },
) {
  const encodedId = encodeURIComponent(id);
  return request<API.CommonResult>(`/dev-ops-api/perm/category/delete/${encodedId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /dev-ops-api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/dev-ops-api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 POST /dev-ops-api/rule */
export async function rule(
  body: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/dev-ops-api/rule', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      ...body,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /dev-ops-api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/dev-ops-api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /dev-ops-api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/dev-ops-api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /dev-ops-api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/dev-ops-api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}
